import * as React from 'react';
import { Image, IImageSettings, ImageFetchPriority, IViewPort } from '@msdyn365-commerce/core';
import { IProductListCompactComponentProps } from '../product-list-compact-component';
import { ProductListProduct } from '../../product-list-component/product-list-component';
import { fixImageSettings } from '../../../shared-utils/image-utilities';

export interface IProductImageProps extends IProductListCompactComponentProps {
    className?: string;
    heading?: string;
    product: ProductListProduct;
}

const ProductImage = (props: IProductImageProps) => {
    const {
        context,
        className,
        heading
    } = props;

    const defaultImageSettings: IImageSettings = {
        viewports: {} as IViewPort,
        disableLazyLoad: props.imageSettings?.disableLazyLoad,
        lazyload: Boolean(props.imageSettings?.lazyload),
        quality: props.imageSettings?.quality || 80
    };

    fixImageSettings(defaultImageSettings, false, 1, 150, 150);

    const contextConfig = context.request.app.config?.placeholderImageName;
    const emptyPlaceHolderImage = contextConfig as string;
    let fallbackImageSource = context?.request.apiSettings.baseImageUrl;
    if (fallbackImageSource?.endsWith('/')) {
        fallbackImageSource = fallbackImageSource.slice(0, -1);
    }
    if (emptyPlaceHolderImage) {
        fallbackImageSource = `${fallbackImageSource}${emptyPlaceHolderImage}`;
    }

    return (
        <Image
            requestContext={context.actionContext.requestContext}
            className={className}
            altText={heading}
            title={heading}
            src={props.product.PrimaryImageUrl || fallbackImageSource}
            fallBackSrc={fallbackImageSource}
            gridSettings={context.request.gridSettings!}
            imageSettings={defaultImageSettings}
            loadFailureBehavior='empty'
            bypassHideOnFailure
            shouldUseThumbnails={false}
            fetchPriority={ImageFetchPriority.High}
            tabIndex={0}
        />
    );
};

export default ProductImage;
